import { Task } from '@/shared/types/task';
import { parseISO } from 'date-fns';

const cache = new Map<string, { start: Date; end: Date }>();

export const getTaskTimeRange = (task: Task) => {
  if (!task.dueDate) {
    return null;
  }

  const isMeeting = task.isMeeting === true ? 1 : 0;

  const key = `${task.id}-${task.dueDate}-${task.timeEstimate}-${isMeeting}`;
  if (cache.has(key)) {
    return cache.get(key)!;
  }

  const due = parseISO(task.dueDate);
  const est = task.timeEstimate || 3600;

  const range =
    task.isMeeting === true
      ? {
          start: due,
          end: new Date(due.getTime() + est * 1000),
        }
      : {
          start: new Date(due.getTime() - est * 1000),
          end: due,
        };

  cache.set(key, range);
  return range;
};

/**
 * Диапазон для ОТОБРАЖЕНИЯ задачи в дневной сетке календаря: высота блока
 * отражает остаток времени до дедлайна (timeEstimate − durationFact), а конец
 * привязан к дедлайну. При перерасходе остаток = 0 — блок схлопывается к
 * дедлайну и получает минимальную высоту на этапе позиционирования.
 *
 * Встречи и задачи без оценки времени отдаются полным диапазоном
 * (getTaskTimeRange) без изменений.
 */
export const getTaskDisplayRange = (task: Task) => {
  const range = getTaskTimeRange(task);
  if (!range) {
    return null;
  }

  if (task.isMeeting === true || !task.timeEstimate) {
    return range;
  }

  const spent = Math.max(0, Number(task.durationFact) || 0);
  const remainingSec = Math.max(0, task.timeEstimate - spent);

  return {
    start: new Date(range.end.getTime() - remainingSec * 1000),
    end: range.end,
  };
};
